<template>
    <div>
        <NavComponent></NavComponent>
        <SideBarComponent></SideBarComponent>
        <img class="banner" :src="house_banner" />
        <div class="main content-container">
            <h3 class="app-title">省心搬家</h3>
            <p class="app-title-p"><i class="app-i app-i-left"></i>准时到位<span class="app-title-span">方便舒适</span>效率至上<i class="app-i app-i-right"></i></p>
            <ul>
                <li class="content li1"><span class="left line"></span>拒绝拖延时间,透明的价格计算； 拒绝强制索要小费。<b></b></li>
                <li><img :src="house_img1" /></li>
                <li class="content"><span class="left line"></span>拒绝坐地起价,如果物品很多的时候,要确保物品完整安全的前提下,空间利用最大化给客户节省时间和不必要的路程。<b ></b></li>
                <li><img :src="house_img2" /></li>
                <li><img :src="house_img3" /></li>
                <li class="content li3"><span class="right line"></span>拒绝粗鲁搬运,我们会包装家具,以确保您的物品在搬运的过程中不会有磕碰或损坏。您的搬运物品,家里的墙体,地板,我们都会细心保护拒绝不专业的工具。<b class="angle"></b></li>
                <li><img :src="house_img4" /></li>
                <li class="content li4"><span class="right2 line"></span>一次性解决您车的烦恼，人的烦恼,从门到门,全程服务,让您轻松优雅的随时更换住所。<b class="angle"></b></li>
            </ul>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import house_banner from '@assets/image/manage/house-banner.jpg'
import house_img1 from '@assets/image/manage/house-img1.jpg'
import house_img2 from '@assets/image/manage/house-img2.jpg'
import house_img3 from '@assets/image/manage/house-img3.jpg'
import house_img4 from '@assets/image/manage/house-img4.jpg'

export default {
    name: 'MoveHousePage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            house_banner,house_img1,house_img2,house_img3,house_img4
        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.banner{
    height: auto;
    width: 100%;
}
.main{
    text-align: center;
    padding:5rem 0;
    ul{
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.5rem;
    }
    li{
        width: 15rem;
        height: 12rem;
        box-sizing: border-box;
        background: #f5f5f5;
        font-size: 0.9rem;
        line-height: 1.4rem;
        letter-spacing: 0px;
        color: #3a4a5b;
        position: relative;
        text-align: left;
        b{
            display: block;
            position: absolute;
            width: 1rem;
            height: 1rem;
            background: #f5f5f5;
            right: -0.5rem;
            top: 2rem;
            z-index: 10;
            transform: rotate(45deg);
        }
        .angle{
            position: absolute;
            left: -0.5rem;
        }
        img{
            width: 15rem;
            height: 11.9rem;
        }
    }
    .content{
        padding:1.5rem 2.3rem 0rem;
    }
    .li1{
        padding:2.9rem 1.9rem 0rem;
    }
    .li3{
        padding:2.5rem 1rem 0rem;
    }
    .li4{
        padding:3rem 2.3rem 0rem;
    }
    .line{
        display: block;
        width: 30px;
        height: 4px;
        margin-bottom: 1.2rem;
        border-top: solid 2px #a22915;
    }
    .right{
        position: absolute;
        right: 1.2rem;
        top:1.2rem;
    }
    .right2{
        position: absolute;
        right: 2.4rem;
        top:1.2rem;
    }
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18.8rem;
    }
    .main{
        padding: 3rem 0;
        ul{
            justify-content:center;
        }
    }
}
</style>